// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiAcquisitionsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';

export interface PolygonModel {
  active?: string;
  agent: string;
  comment?: string;
  median_zone: string;
  polygon: google.maps.LatLngLiteral[];
  polygon_id?: string;
  property_type_id?: string;
  property_type?: string;
}
export interface SavePolygonModel {
  country?: string;
  items: PolygonModel[];
}

interface SavePolygonResponse {
  message: string;
  success: boolean;
}

export const savePolygons = apiAcquisitionsPortal.injectEndpoints({
  endpoints: builder => ({
    savePolygons: builder.mutation({
      query: (newPolygon: SavePolygonModel) => ({
        body: newPolygon,
        method: 'PUT',
        url: '/polygon',
      }),
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'savePolygon',
        };
        return modelError;
      },
      transformResponse: (
        response: SavePolygonResponse
      ): SavePolygonResponse => {
        return response;
      },
      invalidatesTags: ['Polygons', 'getSavedIntersections'],
    }),
  }),
});

export const { useSavePolygonsMutation } = savePolygons;
